import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function Example() {
    const [show, setShow] = useState(false);

    return (
        <>
            <Button className='Rules_block_button' variant="info" onClick={() => setShow(true)}>
                Правила проекта
            </Button>

            <Modal
                size="xl"
                show={show}
                onHide={() => setShow(false)}
                dialogClassName="modal-90%"
                aria-labelledby="example-custom-modal-styling-title"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        Правила проекта
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        <h1>Основые правила</h1>
                        <div className='text'>
                            1) Проект является бесплатной и некоммерческой структурой, предоставляющей игровые услуги без каких-либо гарантий правильности работы. Вы соглашаетесь с тем, что любые потерянные вами игровые ресурсы, деньги, пожертвованные на счет аккаунта, товары, купленные путём пожертвования в игровом онлайн магазине, и прочее не возвращаются ни при каких условиях и обстоятельствах. Все перечисления на счет являются добровольными пожертвованиями для развития проекта, а платные услуги предоставляются в качестве благодарности за материальную поддержку.
                        </div>
                        <div className='text'>
                            2) Оплата услуг и пополнение денег на счёт предоставляется только на официальном сайте проекта.
                        </div>
                        <div className='text'>
                            3)Запомните, вы сами несете ответственность за безопасность вашего аккаунта , а также за любые действия, совершенные под этим аккаунтом. Взлом, кража, "играл не я, мой брат/сестра/бабушка/дедушка и прочее"- не являются оправданием. Администрация по возможности возвращает украденные при взломе вещи..
                        </div>
                        <div className='text'>
                            4)Вы подтверждаете свое согласие с тем, что администрация проекта не несет перед вами никакие обязательства, и принимаете то, что игра на проекте предоставляется "как есть" и отказываетесь от каких-либо претензий к их решениям и действиям. Соглашаетесь с тем, что другие члены команды также не несут перед вами каких-либо дополнительных обязательств, кроме общих и должностных, указанных в этом своде правил.
                        </div>
                        <div className='text'>
                            5)При блокировке аккаунта, все игровые ценности, территория и прочее не будут возвращены или переданы третьим лицам. Так же игровые ценности могут быть изъяты или удалены: - если нет доказательств их получения; - если они были получены нечестным путём (при покупки по низкой цене, при раздаче и прочее) или по какой-то ошибке; - в случае нанесения ущерба другим игрокам(при взломе, гриферстве); - если игрок не заходил на сервер более 30 дней.
                        </div>
                        <div className='text'>
                            6)На каждом сервере присутствуют свои внутриигровые правила. За нарушение их Вы в свою очередь получите наказание, поэтому внимательно читайте их. Каждый сервер по-своему уникален.
                        </div>
                        <div className='text'>
                            7)Запомните, Администрация проекта не несёт ответственность за тех игроков, которых вы добавили в приват. В случае обмана, кражи, убийства и прочее - вещи вам скорее всего не вернут, но за гриферство накажут. Если это будет возможно.
                        </div>
                        <div className='text'>
                            8)Запрещена реклама и упоминание сторонних проектов в любом виде.
                        </div>
                        <div className='text'>
                            9)Запрещено использование стороннего программного обеспечения: кликеры, программы для взлома, баги, недочеты, дюпы или другие нестандартные средства для получения преимущества над другими игроками. Помимо этого запрещено распространять любую информацию об их существовании.
                        </div>
                        <div className='text'>
                            10)Запрещены: взлом, попытки взлома чужого аккаунта, разглашение личных данных других игроков(место проживания, IP-адрес, личные фотографии, видеозаписи, контакты, социальные сети и т.д).
                        </div>
                        <div className='text'>
                            11)Управляющий сервера имеет полное право забанить Вас без доказательств(до выяснений обстоятельств).
                        </div>
                        <h1>Правила сервера ClanWar</h1>
                        <div className='text'>
                            1) Нельзя застраивать базу фулл обсидианом должен быть промежуток между ними 1 блок ( Или должна быть дырка с двух сторон 4х4, наказание, снесение обсидиана.).
                        </div>
                        <div className='text'>
                            2) Нельзя заливать свою или чужую базу фулл водой или лавой так как ТНТ не работаю в воде и лаве(Наказание снесение базы под 0).
                        </div>
                    </p>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default Example;